import { AppConfigModel } from '@/models/app/app-config';
import { appConfigSerializer } from '@/providers/serializers/app/app-config';
import { AI_PLAYGROUND_LEARNER, SHOWCASE_DEMO_ACCOUNT } from '@/utils/constants';

export class AppConfigService {

  private static INSTANCE = new AppConfigService();

  static get instance() {
    return this.INSTANCE;
  }

  private APP_CONFIG: string = 'MC_APP_CONFIG';

  private APP_USER_ROLE: string = 'MC_APP_USER_ROLE';


  public async setAppConfig(appConfigModel: AppConfigModel) {
    localStorage.setItem(this.APP_CONFIG, JSON.stringify(appConfigModel));
  }

  public getTenantUrl() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.tenantUrl ? appConfig.tenantUrl : null;
  }

  public getAdminUiAppId() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.adminUiAppId ? appConfig.adminUiAppId : null;
  }

  public getNavigatorBasePath() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.S3_BUCKET_ASSETS_BASE_PATH ? appConfig.S3_BUCKET_ASSETS_BASE_PATH : null;
  }

  public getStaticImageUrl() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.STATIC_IMAGE_URL ? appConfig.STATIC_IMAGE_URL : null;
  }

  public setAppUserRole(userRole: any) {
    localStorage.setItem(this.APP_USER_ROLE, JSON.stringify(userRole));
  }

  public getLoginPageInfo() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.loginPageInfo ? appConfig.loginPageInfo : null;
  }

  public getAppUserRole() {
    let role = null;
    const userRole = localStorage.getItem(this.APP_USER_ROLE);
    if ( userRole ) {
      role = JSON.parse(userRole);
    }
    return role;
  }

  public getShowcaseEndpoint() {
    const appConfig = this.getAppConfig();
    return appConfig ? appConfig.showcase_endpoint : null;
  }


  public getApiUrl() {
    const appConfig = this.getAppConfig();
    return appConfig ? appConfig.api_endpoint_url : process.env.VUE_APP_API_URL;
  }

  public getClientId() {
    return process.env.VUE_APP_CLIENT_ID;
  }

  public getClientKey() {
    return process.env.VUE_APP_CLIENT_KEY;
  }

  public showcaseLearners() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.SHOWCASE_LEARNERS_LIST ? appConfig.SHOWCASE_LEARNERS_LIST : {};
  }

  public getShowcaseCredential() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.SHOWCASE_DEMO_ACCOUNT ? appConfig.SHOWCASE_DEMO_ACCOUNT : SHOWCASE_DEMO_ACCOUNT;
  }

  public getAIPlayground() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.AI_PLAYGROUND_STUDENT ? appConfig.AI_PLAYGROUND_STUDENT : AI_PLAYGROUND_LEARNER;
  }

  private getAppConfig() {
    let appConfig = null;
    const appConfigAsString: string | null = localStorage.getItem(this.APP_CONFIG);
    if (appConfigAsString) {
      const appConfigAsJson = JSON.parse(appConfigAsString);
      appConfig = appConfigSerializer.appConfigModelSerializer(appConfigAsJson);
    }
    return appConfig;
  }

}

export const appConfigService = AppConfigService.instance;
